import { getFirebaseAuthToken } from '../../../utils/firebaseAuthToken';

export const AUDIO_COMPRESSION_PRESETS = [
  {
    id: 'mp3-96k',
    label: '96 kbps',
    bitrateKbps: 96,
    description: 'Closest to the original, lowest risk.',
  },
  {
    id: 'mp3-64k',
    label: '64 kbps',
    bitrateKbps: 64,
    description: 'Good balance of size and speech clarity.',
  },
  {
    id: 'mp3-48k',
    label: '48 kbps',
    bitrateKbps: 48,
    description: 'Aggressive compression, usually still usable for speech.',
    defaultForNewAudio: true,
  },
  {
    id: 'mp3-32k',
    label: '32 kbps',
    bitrateKbps: 32,
    description: 'Smallest test version, quality risk is highest here.',
  },
];

const COMPRESS_ENDPOINT =
  'https://us-central1-guidesofia-access-control.cloudfunctions.net/compressAudioVariant';

const getAuthToken = async (currentUser) => {
  return getFirebaseAuthToken(currentUser);
};

export const compressAndUploadAudioVariant = async ({
  audioUrl,
  sourceAudioUrl,
  currentUser,
  preset,
}) => {
  const targetSourceUrl = sourceAudioUrl || audioUrl;

  if (!targetSourceUrl) {
    throw new Error('Missing source audio URL');
  }

  if (!preset?.id || !preset?.bitrateKbps) {
    throw new Error('Missing compression preset');
  }

  const token = await getAuthToken(currentUser);
  const response = await fetch(COMPRESS_ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      audioUrl: targetSourceUrl,
      sourceAudioUrl: targetSourceUrl,
      preset: {
        id: preset.id,
        label: preset.label,
        bitrateKbps: preset.bitrateKbps,
      },
    }),
  });

  const payload = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(payload?.message || payload?.error || `Compression request failed (${response.status})`);
  }

  return payload;
};
